module.exports = __webpack_public_path__ + "2b9d552bbc1b75591a7996b961bff6a9.mp4";